<template>
    <div class="branding-options">
        <template v-if="templateOptions && templateOptions.length > 0 && selectedTemplate">
            <div class="design-mode-option-label mt-2" :class="customClass">
                <label class="font-weight-500 m-0"> {{ selectLabel }} </label>
                <div class="design-mode-select">
                    <select-field :options="templateOptions" v-model="selectedTemplate" displayKey="id" label="name" :isPremiumOptions="true" />
                </div>
            </div>
            <div class="design-mode-actions mt-3" v-if="showButtons">
                <Btn
                    @click.native="startProcess('save')"
                    :loading="actionType == 'save'"
                    :label="$t('customBrandingTemplate.save')"
                    :disabled="enableAndDisableTheButtonBasedOnOption() || loading"
                />
                
                <Btn
                    @click.native="startProcess('saveAs')"
                    :loading="actionType == 'saveAs'"
                    :label="$t('customBrandingTemplate.saveAsNew')"
                    :disabled="loading"
                />

                <Btn
                    @click.native="startProcess('deleteTemplateConfirmation')"
                    :loading="actionType == 'deleteTemplateConfirmation'"
                    :label="$t('customBrandingTemplate.delete')"
                    :disabled="loading || enableAndDisableTheButtonBasedOnOption()"
                />
            </div>
        </template>
    </div>

</template>

<script>
import SelectField from '@/components/UI/SelectField';
import { mapGetters, mapState, mapActions } from 'vuex';

const customTemplate = require('../../shared/customTemplate');

export default {
    name: "CustomBrandingTemplates",
    props: {
        showButtons: {
            type: Boolean,
            default: false
        },
        selectLabel: {
            type: String,
            default: "Select Design",
        },
        customClass: {
            type: String
        },
        saveOnChange: {
            type: Boolean,
            default: false
        },
        showCurrentPollOnly: {
            type: Boolean,
            default: false
        },
        reRenderData: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            selectedTemplate: null,
            loading: false,
            actionType: null
        }
    },
    components: {
        SelectField
    },
    created() {
        if(this.getSelectedTemplate == null || this.designs.length == 0) {
            this.loadDesign().then(() => {
                this.findCurrentPollTemplate();
                this.loading = false;
            });
        } 
        // else if(this.getSelectedTemplate.id != this.getPollDesignId) {
        //     this.findCurrentPollTemplate();
        // } 
        else {
            this.selectedTemplate = this.getSelectedTemplate;
            this.loading = false;
        }
    },
    computed: {
        ...mapGetters({
            logoImage: 'logoImage',
            getSelectedTemplate: 'getSelectedTemplate',
            designs: 'designs',
            getPollDesignId: 'getPollDesignId',
            isPremium: 'isPremium'
        }),
        ...mapState({
            poll: (state) => state.poll.poll
        }),
        templateOptions() {
            return this.designs;
        }
    },
    methods: {
        ...mapActions(['updateSelectedTemplate', 'loadDesign', 'storeBrandingDesign', 'setDarkMode']),
        updateImage(template) {
            if(template) {
                this.updateTemplate(template);
                this.updateLogo(template);
                // this.updateBackground(template);
            }
        },
        updateTemplate(template) {
            this.updateSelectedTemplate(template).then(() => {
                this.selectedTemplate = template;
            });
        },
        updateLogo(template) {
            let defaultImageName = '/images/logo_neu_weiss_blau_orange.png';
            if(template && template.config.logoImg) {
                defaultImageName = template.config.logoImg;   
            }
            document.getElementById("web-logo").src = defaultImageName;
            return defaultImageName;
        },
        // updateBackground(template) {
        //     if(template && template.config.bg_image_path) {
        //         let findPollBackground = document.getElementsByClassName('poll-content');
        //         if(findPollBackground.length > 0) {
        //             findPollBackground[0].style.backgroundImage = encodeURI("url("+template.config.bg_image_path+")");
        //         }
        //         return template.config.bg_image_path;
        //     }
        //     return '';
        // },
        enableAndDisableTheButtonBasedOnOption() {
            // this.allowToPerformAction = this.selectedTemplate && this.selectedTemplate.isDefault == 1 ? true : this.selectedTemplate.poll_id == this.poll.id ? false : true;
            return this.selectedTemplate && this.selectedTemplate.isDefault == 1 ? true : false;
        },
        startProcess(processName) {
            this.startLoading(processName);
            this.$emit(processName);
        },
        startLoading(processName) {
            this.loading = true;
            this.actionType = processName;
        },
        stopLoading() {
            this.loading = false;
            this.actionType = null;
        },
        renderValue() {
            let value = (this.getSelectedTemplate.config.answerGridSection.selectedMode == 'dark');
            this.setDarkMode(value).then(() => {
                customTemplate.renderHTML(this.getSelectedTemplate);
            });
        },
        findCurrentPollTemplate() {
            for(let i = 0; i < this.designs.length; i++) {
                if(this.designs[i].id == this.getPollDesignId) {
                    this.updateTemplate(JSON.parse(JSON.stringify(this.designs[i])));
                    break;
                }
            }
        }
    },
    watch: {
        selectedTemplate: {
            deep: true,
            handler(newVal) {
                if(this.getSelectedTemplate.name != newVal.name) {
                    this.updateImage(newVal);
                    this.enableAndDisableTheButtonBasedOnOption();
                    this.renderValue();
                    this.$emit('change', {templateChanged: true});
                }
            },
        }
    },
}
</script>
<style scoped lang="scss">
@import '@/styles/style.scss';

.design-mode {
    color: $dark-grey;
    width: 100%;
    font-size: $small;
    padding: 16px;
    .design-mode-option-label {
        width: 50%;
        font-size: $small;
    }
    .design-mode-actions {
        width: 90%;
        display: flex;
        justify-content: space-between;
    }
    .panel-section-header {
        background-color: rgba(0, 0, 0, 0.8);
        padding: 8px 32px;
        margin-bottom: 8px;
        margin-top: 0px;
        line-height: 20px;
        margin-left: -16px;
        margin-right: -16px;
    }
    .custom-logo-image {
        width: 40px;
        height: 40px;
        background: $dark-grey;
        object-fit: contain;
    }
    .logo-manager-parent {
        justify-content: space-between;
        .logo-image-update {
            display: block;
        }
    }
    .logo-link-section {
        .logo-link-input {
            display: flex;
        } 
        p {
            margin-bottom: unset;
            font-size: $very-small;
        }
    }
    .d-flex {
        justify-content: space-between;
    }
}
::v-deep {
    button#dropdownMenuButton {
        width: 100%;
    }
    .dropdown-item {
        padding: unset;
        padding-bottom: 0.25rem;
    }
    .lv-range-slider__fill, .lv-range-slider__knob {
        background-color: $primary !important;
    }
    .lv-range-slider__rail {
        background-color: $primary-hover !important;
        opacity: 0.3;
    }
} 
</style>